import axios from 'axios';
import { store } from '../../App';

// ── Auth token helper ─────────────────────────────────────────────────────────
const getToken = (customToken) =>
  customToken ? `Bearer ${customToken}` : store.getState().globalurl.Authorization;


// ─────────────────────────────────────────────────────────────────────────────
// GET  — params go as query string  ?data={...}
// ─────────────────────────────────────────────────────────────────────────────
export const getApi = async (url, params = {}, customToken = null) => {
  try {
    const token = getToken(customToken);

    console.log("GET →", url);
    console.log("params →", params);

    const response = await axios.get(url, {
      params,                        // axios serialises this as ?data=...
      headers: {
        Authorization:  token,
        'Content-Type': 'application/json',
      },
    });

    console.log("GET response →", response.data);
    return response.data;

  } catch (error) {
    console.error("GET API Error →", error);
    throw error;
  }
};


// ─────────────────────────────────────────────────────────────────────────────
// POST — JSON body
// ─────────────────────────────────────────────────────────────────────────────
export const postApi = async (url, body = {}, customToken = null) => {
  try {
    const token = getToken(customToken);

    console.log("POST →", url);
    console.log("body →", body);

    const response = await axios.post(url, body, {
      headers: {
        Authorization:  token,
        'Content-Type': 'application/json',
      },
    });

    console.log("POST response →", response.data);
    return response.data;

  } catch (error) {
    console.error("POST API Error →", error);
    throw error;
  }
};


// ─────────────────────────────────────────────────────────────────────────────
// POST MULTIPART — file uploads (FormData)
// ─────────────────────────────────────────────────────────────────────────────
export const postMultipartApi = async (url, formData, customToken = null, onProgress = null) => {
  try {
    const token = getToken(customToken);

    console.log("POST MULTIPART →", url);

    const response = await axios.post(url, formData, {
      headers: {
        Authorization: token,
      },
      onUploadProgress: (e) => {
        if (onProgress && e.total) {
          onProgress(Math.round((e.loaded / e.total) * 100));
        }
      },
    });

    console.log("POST MULTIPART response →", response.data);
    return response.data;

  } catch (error) {
    console.error("POST MULTIPART Error →", error);
    throw error;
  }
};